import axios, { AxiosInstance } from "axios";

/** Axios instance preconfigured for the Visitax API */
export const visitaxClient = createVisitaxClient();
/** Axios instance preconfigured for the OpenPay API */
export const openPayClient = createOpenPayClient();

/**
 * Configure an Axios client for the Visitax service.
 * The endpoint is selected depending on the `VITE_VISITAX_NODE` value.
 *
 * @returns Axios instance pointing to the Visitax API.
 */
function createVisitaxClient(): AxiosInstance {
  let baseURL = "";
  switch (import.meta.env.VITE_VISITAX_NODE) {
    case "1":
      baseURL = import.meta.env.VITE_VISITAX_ENDPOINTPROD; // Producción
      break;
    case "2":
      baseURL = import.meta.env.VITE_VISITAX_ENDPOINTSTAGGING; // Staging
      break;
    case "3":
      baseURL = import.meta.env.VITE_VISITAX_ENDPOINTLOCAL; // Local
      break;
  }
  const client = axios.create({ baseURL });
  return client;
}

/**
 * Configure an Axios client for the OpenPay service using environment
 * variables.
 *
 * @returns Axios instance pointing to the OpenPay API.
 */
function createOpenPayClient(): AxiosInstance {
  let baseURL = "";
  switch (import.meta.env.VITE_VISITAX_NODE) {
    case "1":
      baseURL = import.meta.env.VITE_OPENPAY_ENDPOINT_PROD;
      break;
    case "2":
      baseURL = import.meta.env.VITE_OPENPAY_ENDPOINT_SANDBOX;
      break;
    case "3":
      baseURL = import.meta.env.VITE_OPENPAY_ENDPOINT_SANDBOX;
      break;
  }
  const client = axios.create({ baseURL });
  return client;
}

/**
 * Utility flag that indicates if the current environment is production.
 *
 * @returns `true` when running in production mode, otherwise `false`.
 */
export const isProduction = () => import.meta.env.VITE_VISITAX_NODE === "1";
